import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 测试成绩弹窗
import TestResultPopup from "@/components/TestResultPopup";
// 练习成绩弹窗
import ExercisePopup from "@/components/ExercisePopup";
// 打字练习操作栏
import ManipulationMenu from "@/components/ManipulationMenu";
// 打字练习操作栏
import ManipulationMenuPro from "@/components/ManipulationMenuPro";
// 键盘
import Keyboard from "@/components/Keyboard";
// 键盘
import KeyboardPro from "@/components/KeyboardPro";
// 键盘
import Keyboards from "@/components/Keyboards";
// 输入面板
import InputPanel from "@/components/InputPanel";
// 英文输入面板
import EnglishArticleInputPanel from "@/components/EnglishArticleInputPanel";
// 文章输入面板
import ArticleInputPanel from "@/components/ArticleInputPanel";
// 测试到期弹窗
import TimeExpiredPopup from "@/components/TimeExpiredPopup";
// 导航栏
import NavigationBar from "@/components/NavigationBar";
// 工具类
import Utils from "@/utils/index.js";
// 底部 
import CustomBottom from "@/components/CustomBottom";
// axios
import axios from 'axios';
// 自定义输入框
import CustomInput from "@/components/CustomInput";
// 头部
import CustomHead from "@/components/CustomHead";
// 微信登录 
import WeChatLogin from "@/components/WeChatLogin";
// 输入框
import InputPanelPro from "@/components/InputPanelPro";
// 导入x2js
import x2js from "x2js"

// 全局组件挂载
Vue.component('TestResultPopup', TestResultPopup)
Vue.component('ManipulationMenuPro', ManipulationMenuPro)
Vue.component('ExercisePopup', ExercisePopup)
Vue.component('ManipulationMenu', ManipulationMenu)
Vue.component('Keyboard', Keyboard)
Vue.component('Keyboards', Keyboards)
Vue.component('InputPanel', InputPanel)
Vue.component('EnglishArticleInputPanel', EnglishArticleInputPanel)
Vue.component('ArticleInputPanel', ArticleInputPanel)
Vue.component('TimeExpiredPopup', TimeExpiredPopup)
Vue.component('NavigationBar', NavigationBar)
Vue.component('KeyboardPro', KeyboardPro)
Vue.component('CustomInput', CustomInput)
Vue.component('InputPanelPro', InputPanelPro)
Vue.component('CustomHead', CustomHead)
Vue.component('CustomBottom', CustomBottom)
Vue.component('WeChatLogin', WeChatLogin)

// 全局方法挂载
Vue.prototype.utils = Utils;
Vue.prototype.$http = axios;
Vue.prototype.$x2js = new x2js()
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
